var classes = {"notificationContainer":"index-module_notificationContainer__xLNyJ","fixed":"index-module_fixed__aarnv","visible":"index-module_visible__0l4sf","notification":"index-module_notification__mGqHg"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
